'use client'

import React, { useState, useEffect, useCallback } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import dayjs from 'dayjs'
import SubHeader from '../../components/common/SubHeader/SubHeader'
import { getExportLeadDetails } from '../../utils/lead'
import { getSession } from '../../getSession'
import ExportList from './components/list'
import { API_ENDPOINTS } from '../../config/apiEndpoints'

const LeadExportModule = () => {
    const { userId, TokenId } = getSession()
    const [viewMode, setViewMode] = useState('table')
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [totalRecords, setTotalRecords] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(20)
    const [dateRange, setDateRange] = useState({
        from: dayjs().subtract(6, 'day').format('YYYY-MM-DD'),
        to: dayjs().format('YYYY-MM-DD')
    })

    const fetchExportDetails = useCallback(async (page = 1, limit = 20) => {
        setLoading(true)
        try {
            const param = {
                UserId: userId,
                FromDate: dateRange.from,
                ToDate: dateRange.to,
                OffsetValue: (page - 1) * limit,
                PagingSize: limit,
                Draw: page
            }

            const payload = {
                Token: TokenId || '33BB4E08-B603-4B9F-83FE-D78D1C765431', // Fallback or use proper token
                LoggedUserId: userId,
                Message: "",
                MAC_Address: "",
                IP_Address: "",
                Details: param
            }

            const response = await getExportLeadDetails(payload)
            if (response.Status === 1 && response.Details) {
                setData(response.Details.data || [])
                setTotalRecords(response.Details.recordsTotal || 0)
            } else {
                setData([])
                setTotalRecords(0)
            }
        } catch (error) {
            console.error('Fetch Export Details Error:', error)
            setData([])
        } finally {
            setLoading(false)
        }
    }, [userId, TokenId, dateRange])

    useEffect(() => {
        fetchExportDetails(currentPage, itemsPerPage)
    }, [fetchExportDetails, currentPage, itemsPerPage])

    const handleDateChange = (from, to) => {
        setDateRange({ from, to })
        setCurrentPage(1)
    }

    return (
        <Box className="lead-export-module premium-theme" sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', width: '100%', maxWidth: 'none !important' }}>
            <SubHeader
                title="Lead Export Status"
                showSearch={false}
                showViewSwitcher={true}
                viewMode={viewMode}
                setViewMode={setViewMode}
                showDatePicker={true}
                fromDate={dateRange.from}
                toDate={dateRange.to}
                onDateChange={(range) => handleDateChange(range.startDate, range.endDate)}
                showExport={false}
                showAddButton={false}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {/* Add any extra filters if needed */}
                </Box>
            </SubHeader>

            <Box className="module-content-wrapper" sx={{ p: 6, width: '100%', maxWidth: 'none', flex: 1, display: 'flex', flexDirection: 'column' }}>
                <ExportList
                    viewMode={viewMode}
                    data={data}
                    loading={loading}
                    totalRecords={totalRecords}
                    currentPage={currentPage}
                    itemsPerPage={itemsPerPage}
                    onPageChange={setCurrentPage}
                    onItemsPerPageChange={setItemsPerPage}
                    onRefresh={fetchExportDetails}
                />
            </Box>
        </Box>
    )
}

export default LeadExportModule
